export const IAlert = Object.freeze({
  picto: "picto",
  type: "type",
});

export class AlertModel {
  constructor(data = {}) {
    this[IAlert.picto] = data[IAlert.picto];
    this[IAlert.type] = data[IAlert.type];
  }

  getPicto() {
    return this[IAlert.picto];
  }

  getType() {
    return this[IAlert.type];
  }
}
